import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Representatives as RepresentativesUi, Spinner } from "@madmedical/ui";
import { invariant } from "@madmedical/utils";
import { useState } from "react";
import { useMe } from "@madmedical/user";
import { useGetInvitesQuery, useGetRepresentativesQuery } from "./api";
import InviteModal from "./modals/InviteModal";
import EditInviteModal from "./modals/EditInviteModal";
import EditRepresentativeModal from "./modals/EditRepresentativeModal";
import DeleteInviteDialog from "./modals/DeleteInviteDialog";
import DeleteRepresentativeDialog from "./modals/DeleteRepresentativeDialog";
import ReInviteDialog from "./modals/ReInviteDialog";
var ModalMode;
(function (ModalMode) {
    ModalMode[ModalMode["Closed"] = 0] = "Closed";
    ModalMode[ModalMode["Invite"] = 1] = "Invite";
    ModalMode[ModalMode["EditInvite"] = 2] = "EditInvite";
    ModalMode[ModalMode["EditRepresentative"] = 3] = "EditRepresentative";
    ModalMode[ModalMode["DeleteInvite"] = 4] = "DeleteInvite";
    ModalMode[ModalMode["DeleteRepresentative"] = 5] = "DeleteRepresentative";
    ModalMode[ModalMode["ReInvite"] = 6] = "ReInvite";
})(ModalMode || (ModalMode = {}));
const Representatives = () => {
    var _a;
    const { patient } = useMe();
    const { data: representatives, isLoading: isRepresentativesLoading } = useGetRepresentativesQuery();
    const { data: invites, isLoading: isInvitesLoading } = useGetInvitesQuery();
    const [modalMode, setModalMode] = useState(ModalMode.Closed);
    const [idForModal, setIdForModal] = useState();
    if (isRepresentativesLoading || isInvitesLoading) {
        return _jsx(Spinner, {});
    }
    const handleInvitePress = () => {
        setModalMode(ModalMode.Invite);
    };
    const handleEditPress = ({ id, status }) => {
        setIdForModal(id);
        setModalMode(status ? ModalMode.EditRepresentative : ModalMode.EditInvite);
    };
    const handleReInvitePress = ({ id, status }) => {
        invariant(!status);
        setIdForModal(id);
        setModalMode(ModalMode.ReInvite);
    };
    const handleDeletePress = ({ id, status }) => {
        setIdForModal(id);
        setModalMode(status ? ModalMode.DeleteRepresentative : ModalMode.DeleteInvite);
    };
    const handleModalClose = () => {
        setModalMode(ModalMode.Closed);
        setIdForModal(undefined);
    };
    invariant(representatives);
    invariant(invites);
    invariant(patient);
    const data = representatives
        .map(({ userId, fullName, note }) => ({
        id: userId,
        nameOrEmail: fullName,
        note,
        status: true,
    }))
        .concat(invites.map(({ id, email, note }) => ({
        id,
        nameOrEmail: email,
        note,
        status: false,
    })));
    const packages = ((_a = patient === null || patient === void 0 ? void 0 : patient.packages) !== null && _a !== void 0 ? _a : []);
    if (patient && packages.some((item) => (item === null || item === void 0 ? void 0 : item.type) === "basic")) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(RepresentativesUi, { data: data, maxRepresentatives: patient.maxRepresentativeCount, onInvitePress: handleInvitePress, onResendPress: handleReInvitePress, onEditPress: handleEditPress, onDeletePress: handleDeletePress }), _jsx(InviteModal, { open: modalMode === ModalMode.Invite, onClose: handleModalClose }), _jsx(EditInviteModal, { id: idForModal, open: modalMode === ModalMode.EditInvite, onClose: handleModalClose }), _jsx(EditRepresentativeModal, { userId: idForModal, open: modalMode === ModalMode.EditRepresentative, onClose: handleModalClose }), _jsx(DeleteInviteDialog, { id: idForModal, open: modalMode === ModalMode.DeleteInvite, onClose: handleModalClose }), _jsx(DeleteRepresentativeDialog, { userId: idForModal, open: modalMode === ModalMode.DeleteRepresentative, onClose: handleModalClose }), _jsx(ReInviteDialog, { id: idForModal, open: modalMode === ModalMode.ReInvite, onClose: handleModalClose })] }));
};
export default Representatives;
